import { FC, ReactNode } from "react"
import clsx from "clsx"

export type ButtonVariant = "primary" | "secondary" | "outline" | "ghost" | "error" | "success" | "neutral"
export type ButtonSize = "xs" | "sm" | "md"

const VARIANT_CLASS: Record<ButtonVariant, string> = {
  primary: "btn-primary",
  secondary: "btn-secondary",
  outline: "btn-outline",
  ghost: "btn-ghost",
  error: "btn-error",
  success: "btn-success",
  neutral: ""
}

const SIZE_CLASS: Record<ButtonSize, string> = {
  xs: "btn-xs",
  sm: "btn-sm",
  md: ""
}

interface ButtonProps {
  children: ReactNode
  onClick?: () => void | Promise<void>
  variant?: ButtonVariant
  size?: ButtonSize
  loading?: boolean
  disabled?: boolean
  type?: "button" | "submit"
  className?: string
  ariaLabel?: string
  title?: string
}

export const Button: FC<ButtonProps> = ({
  children,
  onClick,
  variant = "neutral",
  size = "md",
  loading = false,
  disabled = false,
  type = "button",
  className,
  ariaLabel,
  title
}) => (
  <button
    type={type}
    aria-label={ariaLabel}
    title={title}
    className={clsx("btn", VARIANT_CLASS[variant], SIZE_CLASS[size], className)}
    onClick={onClick}
    disabled={disabled || loading}
  >
    {loading ? <span className="loading loading-spinner loading-sm" /> : children}
  </button>
)
